import React, { useEffect, useState, useRef, useContext } from "react";
import { useTheme } from "@mui/material/styles";
import {
  Grid,
  Box,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  IconButton,
  useMediaQuery,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextareaAutosize,
  Backdrop,
  CircularProgress,
  Chip,
  Tooltip,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import CommentIcon from "@mui/icons-material/Comment";
import { useSelector, useDispatch } from "react-redux";
import {
  GetWeekStatus,
  setState,
  getQuotaDetails,
  GetQuotaDetailsForScenario,
  PostOrderDecision,
  DoNothingMarked,
  SubmitModification,
  GetBlockedCustomersConsumption,
  RecallModification,
  StickToQuota,
  GetBlockedCustomersConsumptionforDecision,
  GetBlockedCustomersConsumptionforMSQDecision,
  SubmitOrderDecision
} from "../reviewSlice";
import LabelImportantRoundedIcon from "@mui/icons-material/LabelImportantRounded";
import DownloadDoneRoundedIcon from "@mui/icons-material/DownloadDoneRounded";
import LockOpenRoundedIcon from "@mui/icons-material/LockOpenRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { green, orange, red, grey, blue,purple } from "@mui/material/colors";
import CollapseSection from "../../../components/ui/CollapseSection";
import Modification from "./Modification";
import ModifyOrders from "./ModifyOrders";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import { DataGridPro } from "@mui/x-data-grid-pro";
import muiConfig from '../../../assets/MuiConfig.json'
import ExportIcons from './ExportIcons';
import TotalValueQC from './TotalValueQC';

const DisplayComments = (params) => {
  const [displayComments, setDisplayComments] = useState("");
  const [userComments, setUserComments] = useState("");
  const [open, setOpen] = useState(false);
  const desiredcolor =
    params.comments.length > 0 &&
    params.comments != "Default Customer quota record"
      ? "#891515"
      : "black";

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const handleConfirm = () => {
    setDisplayComments(userComments);
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton onClick={() => setOpen(true)} title={params.comments}>
        {params.comments ? (
          <ForumOutlinedIcon title={params.comments} sx={{ color: "#891515" }} />
        ) : (
          <ForumOutlinedIcon />
        )}
      </IconButton>

      <Dialog
        disableEnforceFocus
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">Comments</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <TextareaAutosize
              onChange={(event) => setUserComments(event.target.value)}
              aria-label="minimum height"
              minRows={5}
              readOnly
              placeholder="Comments"
              style={{ width: 500, fontSize: 18 }}
              defaultValue={params.comments}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            size="small"
            sx={{
              bgcolor: "darkred.light",
              color: "white.main",
              fontWeight: "700",
              textTransform: "none",
              "&:hover": {
                 bgcolor: "darkred.main",
              },
             
          }}
          >
            Cancel
          </Button>
          {/* <Button
                        autoFocus
                        variant="contained"
                        onClick={handleConfirm}
                        size="small"
                        style={{
                            background: "#286aa6",
                            color: "white",
                            borderRadius: "4px",
                        }}
                    >
                        Save Changes
                    </Button> */}
        </DialogActions>
      </Dialog>
    </>
  );
};

const QuotaandConsumption = ({ setIsModificationOpened }) => {
    
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const [searchCustomer, setSearchCustomer] = useState("");
  const [searchProduct, setSearchProduct] = useState("");
  //const [pageSize, setPageSize] = React.useState(20);
  const [rows, setRows] = useState([]);
  const QCRef = useRef(null);
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  const [isDisplayBlockedCustomers, setIsDisplayBlockedCustomers] =
    useState(false);
  const [currentWeek, setCurrentWeek] = useState(0);
  const [isCollapseOpened, setIsCollapseOpened] = useState(false);
  const theme = useTheme();
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 20,
    page: 0
  });
  const [isAll, setIsAll] = useState(false); 
  const [isFullOrderModification, setIsFullOrderModification] = useState(false);
  const [isStickToQuota, setIsStickToQuota] = useState(false);
  const dispatch = useDispatch();
  const review = useSelector((state) => state.review);
  const prevRowSelectionModel = useRef([]);
  const {
    isLoading,
    getQuotaDetails,
    ModifiedList,
    selectedCountryID,
    selectedScenario,
    selectedScenarioID,
    selectedScenarioName,
    selectedQuotaID,
    clearQCTable,
    getWeekStatus,
    quotaConsumptionTableState,
    QCcustomerSearch,
    QCproductSearch,
    RecallList,
    isRecallClicked,
    getScenarios,
    customerListForDecision,
    omIsDisplayBlocked,
    onUnblockClicked,
    onMSQClicked,
    modificationId,
    onUnblockClickedSubmitted
  } = review;

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const setModal = (newPaginationModel) => {
    if(newPaginationModel.pageSize === muiConfig.DataGrid_All && newPaginationModel.page === 0 && rows?.length > 100){
    setIsAll(true);
    }else{
    setIsAll(false);
    }
    setPaginationModel(newPaginationModel);  
  }

  function getChipProps(params) {
    if (params.value ===  "Low") {
      return {
        label: "Low",
        style: {
          fontWeight: "bold",
          borderColor: red[500],
          backgroundColor: red[50],
          color: red[500],
        },
      };
    } else if (params.value === "Medium") {
      return {
        label: "Medium",
        style: {
          fontWeight: "bold",
          borderColor: orange[500],
          backgroundColor: orange[50],
          color: orange[500],
        },
      };
    } else if (params.value === "High") {
      return {
        label: "High",
        style: {
          fontWeight: "bold",
          borderColor: green[500],
          backgroundColor: green[50],
          color: green[500],
        },
      };
    } 
    else if (params.value === "New") {
      return {
        label: "New",
        style: {
          fontWeight: "bold",
          borderColor: purple[500],
          backgroundColor: purple[50],
          color: purple[500],
        },
      };
    }
    
    else {
      return {
        label: "Other",
        style: {
          fontWeight: "bold",
          borderColor: blue[500],
          backgroundColor: blue[50],
          color: blue[500],
        },
      };
    }
  }

  useEffect(() => {
    if (getQuotaDetails?.depletionModel?.toLowerCase() === "none") {
      setCurrentWeek(1);
    } else if (getQuotaDetails?.depletionModel?.toLowerCase() === "biweekly") {
      if (getWeekStatus.chkFirstHalf == true) {
        setCurrentWeek(1);
      } else if (getWeekStatus.chkSecondHalf == true) {
        setCurrentWeek(2);
      }
    } else {
      if (getWeekStatus.chkMonth == true) {
        if (getWeekStatus.chkWeek1 == true) {
          setCurrentWeek(1);
        } else if (getWeekStatus.chkWeek2 == true) {
          setCurrentWeek(2);
        } else if (getWeekStatus.chkWeek3 == true) {
          setCurrentWeek(3);
        } else if (getWeekStatus.chkWeek4 == true) {
          setCurrentWeek(4);
        } else if (getWeekStatus.chkWeek5 == true) {
          setCurrentWeek(5);
        }
      } else {
        setCurrentWeek(0);
      }
    }
  }, [getWeekStatus]);

  const w = 95;
  const columns = [
    {
      field: "customerName",
      headerName: "Customer / CG",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "sapCustomerNumber",
      headerName: "Customer Number",
      flex: 1,
      minWidth: 90,
    },
    {
      field: "skuName",
      headerName: "SKU / PG",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "skuNumb",
      headerName: "SKU Number",
      flex: 1,
      minWidth: 90,
    },
    {
      field: "customerTrustLevel",
      headerName: "Relationship Level",
      flex: 1,
      minWidth: 110,
      align: "center",
      renderCell: (params) => {
        return (
          <Chip
            sx={{ height: "1.8rem", minHeight : "1.8rem", padding: "0.2rem", }}
            {...getChipProps(params)}
          />
        );
      },
      // renderCell: (cellValues) => {

      //     let iconStyle = "";
      //     if (cellValues.value === "High") {
      //         iconStyle = "green";
      //     } else if (cellValues.value === "Medium") {
      //         iconStyle = "orange";
      //     } else if (cellValues.value === "Low") {
      //         iconStyle = "red";
      //     } else if (cellValues.value === "Others") {
      //         iconStyle = "blue";
      //     } else {
      //         iconStyle = "displayNone";
      //     }
      //     console.log(iconStyle)
      //     return (
      //         <span title={cellValues.value}>
      //             <FiberManualRecordIcon color={iconStyle} />
      //         </span>
      //     );
      // },
    },
    {
      field: "orderStatus",
      headerName: "Order Status",
      flex: 1,
      minWidth: 100,
      align: "center",
      renderCell: (params) => (
        <Tooltip
          title={params.row.salesOrder.toString()}
          sx={{ fontSize: "16px", backgroundColor: "white", color: "black" }}
        >
          <span>
            {params.value === "Blocked and reviewed"
              ? "Reviewed"
              : params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "unusedQuota",
      headerName: "Unused Quota - Previous Period",
      minWidth: 70,
      width: 90,
      align: "center",
      headerAlign: "center",
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString('en-US');
        return formattedValue;
      },

    },
    {
      field: "quota",
      headerName: "Quota",
      flex: 1,
      minWidth: 70,
      align: "center",
      headerAlign: "center",
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString('en-US');
        return formattedValue;
      } 
    },
    {
      field: "consumption",
      headerName: "Consumption",
      flex: 1,
      minWidth: 100,
      align: "center",
      headerAlign: "center",
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString('en-US');
        return formattedValue;
      } 
    },
    {
      field: "availableQuota",
      headerName: "Available Quota",
      flex: 1,
      minWidth: 90,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => {
        let availableQuota = 0;
        if (getQuotaDetails?.depletionModel?.toLowerCase() === "none") {
          availableQuota = params.row.weekly1 - params.row.consumption;
        } else if (
          getQuotaDetails?.depletionModel?.toLowerCase() === "biweekly"
        ) {
          if (currentWeek === 1) {
            availableQuota = params.row.weekly1 - params.row.consumption;
          } else {
            availableQuota = params.row.weekly2 - params.row.consumption;
          }
        } else {
          if (currentWeek === 1) {
            availableQuota = params.row.weekly1 - params.row.consumption;
          } else if (currentWeek === 2) {
            availableQuota = params.row.weekly2 - params.row.consumption;
          } else if (currentWeek === 3) {
            availableQuota = params.row.weekly3 - params.row.consumption;
          } else if (currentWeek === 4) {
            availableQuota = params.row.weekly4 - params.row.consumption;
          } else {
            availableQuota = params.row.weekly5 - params.row.consumption;
          }
        }
        return availableQuota;
      },
      cellClassName: "lightblue-background",
      headerClassName: "lightblue-background-header"
    },
    {
      field: "intendedQuantity",
      headerName: "Intended Quantity",
      flex: 1,
      minWidth: 90,
      align: "center",
      headerAlign: "center",
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString('en-US');
        return formattedValue;
      },
      cellClassName: "lightblue-background", 
      headerClassName: "lightblue-background-header"
    },
    // {
    //   field: "modifiedOrderQtyUoM",
    //   headerName: "Modified Quantity",
    //   flex: 1,
    //   minWidth: 100,
    //   valueFormatter: (params) => {
    //     const formattedValue = params.value?.toLocaleString();
    //     return formattedValue;
    //   } 
    // },
    {
      field: "weekly1",
      headerName:
        getQuotaDetails?.depletionModel?.toLowerCase() === "none"
          ? "Final Quota"
          : getQuotaDetails?.depletionModel?.toLowerCase() === "biweekly"
          ? "First Half"
          : "Week1",
      flex: 1,
      minWidth: 80,
      align: "center",
      headerAlign: "center",
      // renderCell: (cellValues) => {
      //   return (
      //     <div>
      //       <span>{cellValues.value?.toLocaleString()}</span>
      //       <br />
      //       <span style={{ color: "blue" }}>{cellValues.value?.toLocaleString()}</span>
      //     </div>
      //   );
      // },
    },
    {
      field: "weekly2",
      headerName:
        getQuotaDetails?.depletionModel?.toLowerCase() === "biweekly"
          ? "Second Half"
          : "Week2",
      flex: 1,
      minWidth: 80,
      align: "center",
      headerAlign: "center",
      // renderCell: (cellValues) => {
      //   let weekly1 = cellValues.row.weekly1;
      //   let weekly2 = cellValues.row.weekly2;
      //   let diff = weekly2 - weekly1;

      //   return (
      //     <div>
      //       <span>{cellValues.value?.toLocaleString()}</span>
      //       <br />
      //       <span style={{ color: "blue" }}>{diff?.toLocaleString()}</span>
      //     </div>
      //   );
      // },
    },
    {
      field: "weekly3",
      headerName: "Week3",
      flex: 1,
      minWidth: 80,
      align: "center",
      headerAlign: "center",
      // renderCell: (cellValues) => {
      //   let weekly2 = cellValues.row.weekly2;
      //   let weekly3 = cellValues.row.weekly3;
      //   let diff = weekly3 - weekly2;

      //   return (
      //     <div>
      //       <span>{cellValues.value?.toLocaleString()}</span>
      //       <br />
      //       <span style={{ color: "blue" }}>{diff?.toLocaleString()}</span>
      //     </div>
      //   );
      // },
    },
    {
      field: "weekly4",
      headerName: "Week4",
      flex: 1,
      minWidth: 80,
      align: "center",
      headerAlign: "center",
      // renderCell: (cellValues) => {
      //   let weekly3 = cellValues.row.weekly3;
      //   let weekly4 = cellValues.row.weekly4;
      //   let diff = weekly4 - weekly3;

      //   return (
      //     <div>
      //       <span>{cellValues.value?.toLocaleString()}</span>
      //       <br />
      //       <span style={{ color: "blue" }}>{diff?.toLocaleString()}</span>
      //     </div>
      //   );
      // },
    },
    {
      field: "weekly5",
      headerName: "Week5",
      flex: 1,
      minWidth: 80,
      align: "center",
      headerAlign: "center",
      // renderCell: (cellValues) => {
      //   let weekly4 = cellValues.row.weekly4;
      //   let weekly5 = cellValues.row.weekly5;
      //   let diff = weekly5 - weekly4;

      //   return (
      //     <div>
      //       <span>{cellValues.value?.toLocaleString()}</span>
      //       <br />
      //       <span style={{ color: "blue" }}>{diff?.toLocaleString()}</span>
      //     </div>
      //   );
      // },
    },
    {
      field: "todaysConsumption",
      headerName: "Today's Consumption",
      flex: 1,
      minWidth: 90,
      align: "center",
      headerAlign: "center",
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString('en-US');
        return formattedValue;
      } 
    },
    {
      field: "yesterdaysConsumption",
      headerName: "Yesterday's Consumption",
      flex: 1,
      minWidth: 90,
      align: "center",
      headerAlign: "center",
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString('en-US');
        return formattedValue;
      } 
    },
    {
        field: "deliveredQuantity",
        headerName: "Delivered Quantity",
        flex: 1, minWidth: 80,
        align: "center",
        headerAlign: "center",
    },
    {
      field: "stickToQuota",
      editable: false,
      headerName: "AT-STQ",
      flex: 1,
      minWidth: 80,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        let checked = cellValues.row.stickToQuota;
        const label = { inputProps: { "aria-label": "Checkbox" } };
        return checked === 1 ? (
          <Checkbox {...label} defaultChecked disabled />
        ) : (
          <Checkbox {...label} disabled />
        );
      },
    },
    {
      field: "sit",
      headerName: "SIT",
      flex:1,
      align: "center",
      headerAlign: "center",
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString('en-US');
        return formattedValue;
      } 
    },
    {
      field: "customerComments",
      headerName: "Comments",
      flex: 1,
      minWidth: 100,
      renderCell: (cellValues) => {
        return <DisplayComments readonly comments={cellValues.value} />;
      },
    },
  ];

  const handleSearchCustomer = (e) => {
    const value = e.target.value;
    setSearchCustomer(value);
  };

  const handleSearchProduct = (e) => {
    const value = e.target.value;
    setSearchProduct(value);
  };
  useEffect(() => {
    setSearchCustomer(QCcustomerSearch);
    setSearchProduct(QCproductSearch);
  }, [QCcustomerSearch, QCproductSearch]);

  const handleRetrive = (isRecall, customerList, isFullOrder) => {
    debugger;

//     let QuotadetailsListFilter = JSON.parse(JSON.stringify(getQuotaDetails));
// const filteredCustomers = QuotadetailsListFilter.quotaCusumptionCustomers.filter(
//   (customer) => customer.customerQuotas_SentToSAP === 'Y'
// );


// const QuotaDetailsSentSAP_Y = {
//   ...QuotadetailsListFilter,
//   quotaCusumptionCustomers: filteredCustomers,
// };



    dispatch(setState("isModifyClicked", true));
    dispatch(setState("onUnblockClicked", false));
    dispatch(setState("onMSQClicked", false));
    dispatch(setState("isCurrentWeekRowChanged", false));
    dispatch(setState("customerListForDecision", []));
    dispatch(setState("customerListForDecisionSubmission", []));
    if (isRecall) {
      if (getQuotaDetails?.quotaCusumptionCustomers?.length > 0) {
        let getRecallModList = JSON.parse(JSON.stringify(getQuotaDetails));
        let consumptionList = getRecallModList?.quotaCusumptionCustomers;
        if (consumptionList?.length > 0) {
          for (let i = 0; i < RecallList?.length; i++) {
            let index = consumptionList.findIndex(
              (x) => x.customerQuotaID === RecallList[i]?.customerQuotaID
            );
            if (index !== -1) {
              consumptionList[index].newFinalQuota.weekly1 =
                RecallList[i]?.weekly1;
              consumptionList[index].newFinalQuota.weekly2 =
                RecallList[i]?.weekly2;
              consumptionList[index].newFinalQuota.weekly3 =
                RecallList[i]?.weekly3;
              consumptionList[index].newFinalQuota.weekly4 =
                RecallList[i]?.weekly4;
              consumptionList[index].newFinalQuota.weekly5 =
                RecallList[i]?.weekly5;
              consumptionList[index].deltaModification.weekly1 = 
              consumptionList[index].newFinalQuota.weekly1 - consumptionList[index].lastApproved.weekly1;
              consumptionList[index].deltaModification.weekly2 = 
              consumptionList[index].newFinalQuota.weekly2 - consumptionList[index].lastApproved.weekly2;
              consumptionList[index].deltaModification.weekly3 = 
              consumptionList[index].newFinalQuota.weekly3 - consumptionList[index].lastApproved.weekly3;
              consumptionList[index].deltaModification.weekly4 = 
              consumptionList[index].newFinalQuota.weekly4 - consumptionList[index].lastApproved.weekly4;
              consumptionList[index].deltaModification.weekly5 = 
              consumptionList[index].newFinalQuota.weekly5 - consumptionList[index].lastApproved.weekly5;
              consumptionList[index].newFinalQuota.customerComments =
                RecallList[i]?.customerComments;
            }
          }
        }
        getRecallModList.quotaCusumptionCustomers = consumptionList;
        dispatch(setState("ModifiedList", getRecallModList));
        dispatch(
          setState(
            "updatedWeeklyData",
            getRecallModList?.quotaCusumptionCustomers
          )
        );
        const customerquotaids = quotaConsumptionTableState.map(item => item.customerQuotaID);
        const allMatch = rowSelectionModel.every(id => customerquotaids.includes(id));
        if (customerquotaids.length <= rowSelectionModel.length && allMatch) {
          let List = [];
          for (let i = 0; i < quotaConsumptionTableState?.length; i++) {
            let index = getRecallModList.quotaCusumptionCustomers.findIndex(
              (x) =>
                x.customerQuotaID ===
                quotaConsumptionTableState[i]?.customerQuotaID
            );
            List.push(getRecallModList.quotaCusumptionCustomers[index]);
          }
          dispatch(setState("modifyList", List));
          dispatch(setState("CustomerSearchTxt", searchCustomer));
          dispatch(setState("ProductSearchTxt", searchProduct));
          dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
        } else {
          dispatch(
            setState("modifyList", getRecallModList?.quotaCusumptionCustomers)
          );
          dispatch(setState("CustomerSearchTxt", ""));
          dispatch(setState("ProductSearchTxt", ""));
          dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
        }
      }
      dispatch(setState("isRecallClicked", false));
    } else if (isFullOrder){
      if (customerList && customerList.length > 0) {
        let getModList = JSON.parse(JSON.stringify(getQuotaDetails));
        let consumptionList = getModList?.quotaCusumptionCustomers;
        customerList.forEach((item) => {
          let res = consumptionList.find((p) => p.customerQuotaID === item);
          if (res) {
            let newFinalQuota =res.newFinalQuota ;
            let deltaModification = res.deltaModification;
            let bal = res.revisedQuota + (res.intendedQuantity - (res.revisedQuota - res.consumption));
            if (getQuotaDetails?.depletionModel?.toLowerCase() === "none") {
              newFinalQuota.weekly1 = bal;
              deltaModification.weekly1 = newFinalQuota.weekly1 - res.lastApproved.weekly1;
            } else if(getQuotaDetails?.depletionModel?.toLowerCase() === "biweekly"){
              if (getWeekStatus.chkFirstHalf) {
                newFinalQuota.weekly1 = bal;
                deltaModification.weekly1 = newFinalQuota.weekly1 - res.lastApproved.weekly1;
                validateUpdateWeeksBiweekly(res);
              } else if (getWeekStatus.chkSecondHalf) {
                newFinalQuota.weekly2 = bal;
                deltaModification.weekly2 = newFinalQuota.weekly2 - res.lastApproved.weekly2;
              }
            }
            else {
              if (getWeekStatus.chkWeek1) {
                newFinalQuota.weekly1 = bal;
                deltaModification.weekly1 = newFinalQuota.weekly1 - res.lastApproved.weekly1;
                validateUpdateWeeks(res, 1);
              } else if (getWeekStatus.chkWeek2) {
                newFinalQuota.weekly2 = bal;
                deltaModification.weekly2 = newFinalQuota.weekly2 - res.lastApproved.weekly2;
                validateUpdateWeeks(res, 2);
              } else if (getWeekStatus.chkWeek3) {
                newFinalQuota.weekly3 = bal;
                deltaModification.weekly3 = newFinalQuota.weekly3 - res.lastApproved.weekly3;
                validateUpdateWeeks(res, 3);
              } else if (getWeekStatus.chkWeek4) {
                newFinalQuota.weekly4 = bal;
                deltaModification.weekly4 = newFinalQuota.weekly4 - res.lastApproved.weekly4;
                validateUpdateWeeks(res, 4);
              } else if (getWeekStatus.chkWeek5) {
                newFinalQuota.weekly5 = bal;
                deltaModification.weekly5 = newFinalQuota.weekly5 - res.lastApproved.weekly5;
              }
            }
          }
          });
            getModList.quotaCusumptionCustomers = consumptionList;
            dispatch(setState("ModifiedList", getModList));
            dispatch(
              setState(
                "updatedWeeklyData",
                getModList?.quotaCusumptionCustomers
              )
            );
            const customerquotaids = quotaConsumptionTableState.map(item => item.customerQuotaID);
            const allMatch = rowSelectionModel.every(id => customerquotaids.includes(id));
            if (customerquotaids.length <= rowSelectionModel.length &&allMatch) {
              let List = [];
              for (let i = 0; i < quotaConsumptionTableState?.length; i++) {
                let index = getModList.quotaCusumptionCustomers.findIndex(
                  (x) =>
                    x.customerQuotaID ===
                    quotaConsumptionTableState[i]?.customerQuotaID
                );
                List.push(getModList.quotaCusumptionCustomers[index]);
              }
              dispatch(setState("modifyList", List));
              dispatch(setState("CustomerSearchTxt", searchCustomer));
              dispatch(setState("ProductSearchTxt", searchProduct));
              dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
            } else {
              dispatch(
                setState("modifyList", getModList?.quotaCusumptionCustomers)
              );
              dispatch(setState("CustomerSearchTxt", ""));
              dispatch(setState("ProductSearchTxt", ""));
              dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
            }
      }
    }
    else {
      dispatch(setState("ModifiedList", getQuotaDetails));
      //dispatch(setState("ModifiedList", QuotaDetailsSentSAP_Y));
      dispatch(
        setState("updatedWeeklyData", getQuotaDetails?.quotaCusumptionCustomers)
        //setState("updatedWeeklyData", filteredCustomers)
      );
      const customerquotaids = quotaConsumptionTableState.map(item => item.customerQuotaID);
      const allMatch = rowSelectionModel.every(id => customerquotaids.includes(id));
      if (customerquotaids.length <= rowSelectionModel.length && allMatch) {
        dispatch(setState("modifyList", quotaConsumptionTableState));
        dispatch(setState("CustomerSearchTxt", searchCustomer));
        dispatch(setState("ProductSearchTxt", searchProduct));
        dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
      } else {
        dispatch(
          setState("modifyList", getQuotaDetails?.quotaCusumptionCustomers)
          //setState("modifyList", filteredCustomers)
        );
        dispatch(setState("CustomerSearchTxt", ""));
        dispatch(setState("ProductSearchTxt", ""));
        dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
      }
    }
    dispatch(setState("displayModification", true));
    setIsModificationOpened(true);
  };

  const validateUpdateWeeksBiweekly = (obj)=>{
    if (obj.newFinalQuota.weekly2 < obj.newFinalQuota.weekly1) {
      obj.newFinalQuota.weekly2 = obj.newFinalQuota.weekly1;
      obj.deltaModification.weekly2 = obj.newFinalQuota.weekly2 - obj.lastApproved.weekly2;
    }
  }
  const validateUpdateWeeks = (obj, val) => {
    if (val === 4) {
      if (obj.newFinalQuota.weekly5 < obj.newFinalQuota.weekly4) {
        obj.newFinalQuota.weekly5 = obj.newFinalQuota.weekly4;
        obj.deltaModification.weekly5 = obj.newFinalQuota.weekly5 - obj.lastApproved.weekly5;
      }
    } else if (val === 3) {
      if (obj.newFinalQuota.weekly4 < obj.newFinalQuota.weekly3 && obj.newFinalQuota.weekly5 < obj.newFinalQuota.weekly3) {
        obj.newFinalQuota.weekly5 = obj.newFinalQuota.weekly3;
        obj.newFinalQuota.weekly4 = obj.newFinalQuota.weekly3;
        obj.deltaModification.weekly5 = obj.newFinalQuota.weekly5 - obj.lastApproved.weekly5;
        obj.deltaModification.weekly4 = obj.newFinalQuota.weekly4 - obj.lastApproved.weekly4;
      } else if (obj.newFinalQuota.weekly4 < obj.newFinalQuota.weekly3) {
        obj.newFinalQuota.weekly4 = obj.newFinalQuota.weekly3;
        obj.deltaModification.weekly4 = obj.newFinalQuota.weekly4 - obj.lastApproved.weekly4;
      }
    } else if (val === 2) {
      if (obj.newFinalQuota.weekly3 < obj.newFinalQuota.weekly2 && obj.newFinalQuota.weekly4 < obj.newFinalQuota.weekly2) {
        if (obj.newFinalQuota.weekly5 < obj.newFinalQuota.weekly2) {
          obj.newFinalQuota.weekly5 = obj.newFinalQuota.weekly2;
          obj.newFinalQuota.weekly4 = obj.newFinalQuota.weekly2;
          obj.newFinalQuota.weekly3 = obj.newFinalQuota.weekly2;
          obj.deltaModification.weekly5 = obj.newFinalQuota.weekly5 - obj.lastApproved.weekly5;
          obj.deltaModification.weekly4 = obj.newFinalQuota.weekly4 - obj.lastApproved.weekly4;
          obj.deltaModification.weekly3 = obj.newFinalQuota.weekly3 - obj.lastApproved.weekly3;
        } else {
          obj.newFinalQuota.weekly4 = obj.newFinalQuota.weekly2;
          obj.newFinalQuota.weekly3 = obj.newFinalQuota.weekly2;
          obj.deltaModification.weekly4 = obj.newFinalQuota.weekly4 - obj.lastApproved.weekly4;
          obj.deltaModification.weekly3 = obj.newFinalQuota.weekly3 - obj.lastApproved.weekly3;
        }
      } else if (obj.newFinalQuota.weekly3 < obj.newFinalQuota.weekly2) {
        obj.newFinalQuota.weekly3 = obj.newFinalQuota.weekly2;
        obj.deltaModification.weekly3 = obj.newFinalQuota.weekly3 - obj.lastApproved.weekly3;
      }
    } else if (val === 1) {
      if (obj.newFinalQuota.weekly2 < obj.newFinalQuota.weekly1 && obj.newFinalQuota.weekly3 < obj.newFinalQuota.weekly1 && obj.newFinalQuota.weekly4 < obj.newFinalQuota.weekly1) {
        if (obj.newFinalQuota.weekly5 < obj.newFinalQuota.weekly1) {
          obj.newFinalQuota.weekly5 = obj.newFinalQuota.weekly1;
          obj.newFinalQuota.weekly4 = obj.newFinalQuota.weekly1;
          obj.newFinalQuota.weekly3 = obj.newFinalQuota.weekly1;
          obj.newFinalQuota.weekly2 = obj.newFinalQuota.weekly1;
          obj.deltaModification.weekly5 = obj.newFinalQuota.weekly5 - obj.lastApproved.weekly5;
          obj.deltaModification.weekly4 = obj.newFinalQuota.weekly4 - obj.lastApproved.weekly4;
          obj.deltaModification.weekly3 = obj.newFinalQuota.weekly3 - obj.lastApproved.weekly3;
          obj.deltaModification.weekly2 = obj.newFinalQuota.weekly2 - obj.lastApproved.weekly2;
        } else {
          obj.newFinalQuota.weekly4 = obj.newFinalQuota.weekly1;
          obj.newFinalQuota.weekly3 = obj.newFinalQuota.weekly1;
          obj.newFinalQuota.weekly2 = obj.newFinalQuota.weekly1;
          obj.deltaModification.weekly4 = obj.newFinalQuota.weekly4 - obj.lastApproved.weekly4;
          obj.deltaModification.weekly3 = obj.newFinalQuota.weekly3 - obj.lastApproved.weekly3;
          obj.deltaModification.weekly2 = obj.newFinalQuota.weekly2 - obj.lastApproved.weekly2;
        }
      } else if (obj.newFinalQuota.weekly2 < obj.newFinalQuota.weekly1 && obj.newFinalQuota.weekly3 < obj.newFinalQuota.weekly1) {
        obj.newFinalQuota.weekly3 = obj.newFinalQuota.weekly1;
        obj.newFinalQuota.weekly2 = obj.newFinalQuota.weekly1;
        obj.deltaModification.weekly3 = obj.newFinalQuota.weekly3 - obj.lastApproved.weekly3;
        obj.deltaModification.weekly2 = obj.newFinalQuota.weekly2 - obj.lastApproved.weekly2;
        if (obj.newFinalQuota.weekly5 < obj.newFinalQuota.weekly4) {
          obj.newFinalQuota.weekly5 = obj.newFinalQuota.weekly4;
          obj.deltaModification.weekly5 = obj.newFinalQuota.weekly5 - obj.lastApproved.weekly5;
        }
      } else if (obj.newFinalQuota.weekly2 < obj.newFinalQuota.weekly1) {
        obj.newFinalQuota.weekly2 = obj.newFinalQuota.weekly1;
        obj.deltaModification.weekly2 = obj.newFinalQuota.weekly2 - obj.lastApproved.weekly2;
        if (obj.newFinalQuota.weekly5 < obj.newFinalQuota.weekly4) {
          obj.newFinalQuota.weekly5 = obj.newFinalQuota.weekly4;
          obj.deltaModification.weekly5 = obj.newFinalQuota.weekly5 - obj.lastApproved.weekly5;
        }
      }
    }
  };
  const handleRecallModification = () => {
    dispatch(setState("isModifyClicked", true));
    dispatch(setState("isRecallClicked", true));
    dispatch(RecallModification(getQuotaDetails?.quotaID)).then(() => {
      dispatch(setState("displayModification", true));
      setIsModificationOpened(true);
    });
  };

  // useEffect(() => {
  //     if (getQuotaDetails) {
  //         console.log(getQuotaDetails.quotaCusumptionCustomers)
  //         setRows(getQuotaDetails.quotaCusumptionCustomers);
  //     }
  // }, [getQuotaDetails])

  useEffect(() => {
    if (clearQCTable) {
      setRows([]);
      dispatch(setState("clearQCTable", false));
    }
  }, [clearQCTable]);

  useEffect(() => {
    if (isRecallClicked) {
      if (RecallList.length > 0) {
        handleRetrive(true, [], false);
      }
    }
  }, [RecallList]);

  useEffect(() => {
    if (rows?.length > 0) {
      debugger;
      dispatch(setState("quotaConsumptionTableState", rows));
      if (isDisplayBlockedCustomers) {
        dispatch(setState("modifyList", rows));
        let val = getQuotaDetails?.quotaCusumptionCustomers?.filter(
          (item) => {
            let retVal = false;
            retVal =
              item.orderStatus.toLowerCase().includes("blocked");
            return retVal;
          }
        );
        dispatch(setState("modifyList", val));
        dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
      } else {
        dispatch(
          setState("modifyList", getQuotaDetails?.quotaCusumptionCustomers)
          // setState("modifyList", getQuotaDetails?.quotaCusumptionCustomers?.filter(
          //   (item) => item.customerQuotas_SentToSAP === 'Y'
          // ) )
        );
        dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
      }
    }
  }, [rows]);

  const handleOnCustomerProductChange = (searchCustomer, searchProduct) => {
    if(searchProduct === undefined)setSearchProduct("");
    if(searchCustomer === undefined)setSearchCustomer("");
    filteredRow();
  };

  const filteredRow=()=>{
    debugger;
    setRows((prevVal) => {
      let val = getQuotaDetails?.quotaCusumptionCustomers?.filter(
        (item) => {
          let retVal = false;
          if (
            item.customerName !== undefined &&
            item.sapCustomerNumber !== undefined &&
            searchCustomer !== undefined &&
            item.skuName !== undefined &&
            item.skuNumb !== undefined
          ) {
            if (isDisplayBlockedCustomers) {
              retVal =
                item.orderStatus.toLowerCase().includes("blocked") &&
                (item.customerName
                  .toLowerCase()
                  .includes(searchCustomer.toLowerCase()) ||
                  item.sapCustomerNumber
                    .toLowerCase()
                    .includes(searchCustomer.toLowerCase())) &&
                (item.skuName
                  .toLowerCase()
                  .includes(searchProduct?.toLowerCase()) ||
                  item.skuNumb
                    .toLowerCase()
                    .includes(searchProduct?.toLowerCase()));
            } else {
              retVal =
               (item.customerName
                  .toLowerCase()
                  .includes(searchCustomer.toLowerCase()) ||
                  item.sapCustomerNumber
                    .toLowerCase()
                    .includes(searchCustomer.toLowerCase())) &&
                (item.skuName
                  .toLowerCase()
                  .includes(searchProduct?.toLowerCase()) ||
                  item.skuNumb
                    .toLowerCase()
                    .includes(searchProduct?.toLowerCase()));
            }
          } else {
            return retVal;
          }
          return retVal;
        }
      );
      return val;
    });
  }
  useEffect(() => {
    handleOnCustomerProductChange(searchCustomer, searchProduct);
  }, [searchCustomer]);

  useEffect(() => {
    handleOnCustomerProductChange(searchCustomer, searchProduct);
  }, [searchProduct]);

  useEffect(() => {
    dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
    filteredRow();
  }, [isDisplayBlockedCustomers]);

  /* Generate a random value for unique value every time */

  // function generateRandom() {
  //     var length = 8,
  //         charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
  //         retVal = "";
  //     for (var i = 0, n = charset.length; i < length; ++i) {
  //         retVal += charset.charAt(Math.floor(Math.random() * n));
  //     }
  //     return retVal;
  // }

  useEffect(() => {
    if (rowSelectionModel.length >= 0) {
      //console.log(rowSelectionModel);
      dispatch(setState("checkedCustomersList", rowSelectionModel));
    }
  }, [rowSelectionModel]);

  useEffect(() => {
    if (getQuotaDetails.quotaCusumptionCustomers) {
      debugger;
      setRows(getQuotaDetails.quotaCusumptionCustomers);
      handleOnCustomerProductChange(searchCustomer, searchProduct);
    }
    scrollToThirdDataGrid();
    prevRowSelectionModel.current = [];
  }, [getQuotaDetails.quotaCusumptionCustomers]);

  const scrollToThirdDataGrid = () => {
    setTimeout(() => {
      if (QCRef.current) {
        QCRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 1000);
  };

  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };
  // const SaveOrderDecision = (code) => {
  //   let decisionCode = "";
  //   let desSucmessage = "";
  //   let desSucPartmessage = "";
  //   let obj = {};
  //   let customerList = [];
  //   const newObj = {
  //     scenarioId: selectedScenarioID,
  //     quotaId: selectedQuotaID,
  //   };
  //   if (code == "stick") {
  //     decisionCode = "SQ";
  //     desSucmessage = "Stick to quota orders decision updated successfully.";
  //     desSucPartmessage =
  //       "Stick to quota Orders decision updated successfully for some of the selected customer(s)";
  //   } else if (code == "nothing") {
  //     decisionCode = "ND";
  //     desSucmessage = "Do nothing orders decision updated successfully.";
  //     desSucPartmessage =
  //       "Do nothing Orders decision updated successfully for some of the selected customer(s)";
  //   }
  //  // console.log(rowSelectionModel);
  //   for (let i = 0; i < rowSelectionModel.length; i++) {
  //     const row = rows.find(
  //       (row) => row.customerQuotaID === rowSelectionModel[i]
  //     );
  //     if (row["orderStatus"].toLowerCase() == "blocked") {
  //       customerList.push(row.customerQuotaID);
  //     }
  //     // customerList.push(row["id"]);
  //   }
  //   if (customerList.length == 0) {
  //     console.log("Please select blocked customer(s)");
  //     showMessage("Please select blocked customer(s)", "info");
  //     return;
  //   } else {
  //     obj.countryId = getScenarios.find(
  //       (x) => x.scenarioID === newObj.scenarioId
  //     ).geoID;
  //     obj.scenarioId = selectedScenarioID;
  //     obj.sceanrioName = selectedScenarioName;
  //     obj.blockedcustomers = customerList;
  //     obj.quotaId = selectedQuotaID;
  //     obj.userId = JSON.parse(localStorage.getItem("data")).userID;
  //     obj.decisionCode = decisionCode;
  //     obj.modificationId = 0;
  //     obj.sceanrioName = selectedScenario;
  //     //console.log(obj);
  //     dispatch(StickToQuota(obj)).then(() =>
  //       dispatch(GetQuotaDetailsForScenario(newObj))
  //     );
  //   }
  // };

  // const DoNothing = () => {
  //   let obj = {};
  //   let customerList = [];
  //   const newObj = {
  //     scenarioId: selectedScenarioID,
  //     quotaId: selectedQuotaID,
  //   };
  //   //console.log(rowSelectionModel);
  //   for (let i = 0; i < rowSelectionModel.length; i++) {
  //     const row = rows.find(
  //       (row) => row.customerQuotaID === rowSelectionModel[i]
  //     );
  //     if (row["orderStatus"].toLowerCase() == "blocked") {
  //       customerList.push(row.customerQuotaID);
  //     }
  //     // customerList.push(row["id"]);
  //   }
  //   if (customerList.length == 0) {
  //     console.log("Please select blocked customer(s)");
  //     showMessage("Please select blocked customer(s)", "info");
  //     return;
  //   } else {
  //     obj.countryId = getScenarios.find(
  //       (x) => x.scenarioID === newObj.scenarioId
  //     ).geoID;
  //     obj.scenarioId = selectedScenarioID;
  //     obj.sceanrioName = selectedScenarioName;
  //     obj.blockedcustomers = customerList;
  //     obj.quotaId = selectedQuotaID;
  //     obj.userId = JSON.parse(localStorage.getItem("data")).userID;
  //     obj.decisionCode = "ND";
  //     obj.modificationId = 0;
  //     obj.sceanrioName = selectedScenario;
  //     //console.log(obj);
  //     dispatch(DoNothingMarked(obj)).then(() =>
  //       dispatch(GetQuotaDetailsForScenario(newObj))
  //     );
  //   }
  // };

  // const ModifySQ = () => {
  //   let customerList = [];
  //   for (let i = 0; i < rowSelectionModel.length; i++) {
  //     const row = rows.find(
  //       (row) => row.customerQuotaID === rowSelectionModel[i]
  //     );
  //     if (row["orderStatus"].toLowerCase() == "blocked") {
  //       customerList.push(row.customerQuotaID);
  //     }
  //     // customerList.push(row["id"]);
  //   }
  //   if (customerList.length == 0) {
  //     console.log("Please select blocked customer(s)");
  //     showMessage("Please select blocked customer(s)", "info");
  //     return;
  //   }
  //   dispatch(setState("isModifyClicked", true));
  //   dispatch(setState("onUnblockClicked", false));
  //   dispatch(setState("onMSQClicked", true));
  //   dispatch(setState("isCurrentWeekRowChanged", false));
  //   dispatch(setState("customerListForDecision", []));
  //   dispatch(setState("customerListForDecisionSubmission", []));
  //   let obj = {
  //     blockedcustomers: customerList,
  //     countryId: getScenarios.find((x) => x.scenarioID === selectedScenarioID)
  //       .geoID,
  //     isDisplayOnlyBlockedOrder: 1,
  //     sceanrioName: selectedScenarioName,
  //     scenarioId: selectedScenarioID,
  //     selectedNumberOfDays: 1,
  //   };
  //   dispatch(GetBlockedCustomersConsumptionforMSQDecision(obj)).then(() => {
  //     dispatch(setState("ModifiedList", getQuotaDetails));
  //     dispatch(
  //       setState("updatedWeeklyData", getQuotaDetails?.quotaCusumptionCustomers)
  //     );
  //     if (rowSelectionModel?.length === quotaConsumptionTableState?.length) {
  //       dispatch(setState("modifyList", quotaConsumptionTableState));
  //       dispatch(setState("CustomerSearchTxt", searchCustomer));
  //       dispatch(setState("ProductSearchTxt", searchProduct));
  //       dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
  //     } else {
  //       dispatch(
  //         setState("modifyList", getQuotaDetails?.quotaCusumptionCustomers)
  //       );
  //       dispatch(setState("CustomerSearchTxt", ""));
  //       dispatch(setState("ProductSearchTxt", ""));
  //       dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
  //     }
  //     dispatch(setState("displayModification", true));
  //     setIsModificationOpened(true);
  //   });
  // };

  // const UnblockFullOrder = () => {
  //   let customerList = [];
  //   for (let i = 0; i < rowSelectionModel.length; i++) {
  //     const row = rows.find(
  //       (row) => row.customerQuotaID === rowSelectionModel[i]
  //     );
  //     if (row["orderStatus"].toLowerCase() == "blocked") {
  //       customerList.push(row.customerQuotaID);
  //     }
  //     // customerList.push(row["id"]);
  //   }
  //   if (customerList.length == 0) {
  //     console.log("Please select blocked customer(s)");
  //     showMessage("Please select blocked customer(s)", "info");
  //     return;
  //   }
  //   dispatch(setState("isModifyClicked", true));
  //   dispatch(setState("onUnblockClicked", true));
  //   dispatch(setState("onMSQClicked", false));
  //   dispatch(setState("isCurrentWeekRowChanged", false));
  //   dispatch(setState("customerListForDecision", []));
  //   dispatch(setState("customerListForDecisionSubmission", []));
  //   let obj = {
  //     blockedcustomers: customerList,
  //     countryId: getScenarios.find((x) => x.scenarioID === selectedScenarioID)
  //       .geoID,
  //     isDisplayOnlyBlockedOrder: 1,
  //     sceanrioName: selectedScenarioName,
  //     scenarioId: selectedScenarioID,
  //     selectedNumberOfDays: 1,
  //   };
  //   dispatch(GetBlockedCustomersConsumptionforDecision(obj)).then(() => {});
  // };

  // useEffect(() => {
  //   if (onUnblockClicked) {
  //     if (customerListForDecision?.length > 0) {
  //       let customerListDecision = JSON.parse(
  //         JSON.stringify(customerListForDecision)
  //       );
  //       let customerList = [];
  //       for (let i = 0; i < rowSelectionModel.length; i++) {
  //         const row = rows.find(
  //           (row) => row.customerQuotaID === rowSelectionModel[i]
  //         );
  //         if (row["orderStatus"].toLowerCase() == "blocked") {
  //           customerList.push(row.customerQuotaID);
  //         }
  //       }
  //       dispatch(setState("selectedCustomersForDecision", customerList));
  //       dispatch(setState("onUnblockClicked", true));
  //       dispatch(setState("isCurrentWeekRowChanged", false));
  //       let quotaDetailslist = JSON.parse(JSON.stringify(getQuotaDetails));
  //       let idxs = -1;
  //       for (let i = 0; i < customerList.length; i++) {
  //         let details = {};
  //         for (let j = 0; j < customerListForDecision.length; j++) {
  //           let Ind = customerListForDecision[j].details.findIndex(
  //             (x) => Number(x.customerQuotaId) === Number(customerList[i])
  //           );
  //           if (Ind > -1) {
  //             details = customerListForDecision[j].details[Ind];
  //             idxs = j;
  //             break;
  //           }
  //         }
  //         let idx = quotaDetailslist.quotaCusumptionCustomers.findIndex(
  //           (x) => x.customerQuotaID === Number(customerList[i])
  //         );
  //         let packSize = details.packSize;
  //         let packConversion =
  //          (quotaDetailslist.quotaCusumptionCustomers[idx].intendedQuantity) / 
  //          packSize;
  //         packConversion = Math.round(packConversion);
  //         quotaDetailslist.quotaCusumptionCustomers[idx].modifiedOrderQtyUoM = packConversion * packSize;
  //         if(quotaDetailslist.quotaCusumptionCustomers[idx].modifiedOrderQtyUoM >
  //           quotaDetailslist.quotaCusumptionCustomers[idx].intendedQuantity){
  //             quotaDetailslist.quotaCusumptionCustomers[idx].modifiedOrderQtyUoM = quotaDetailslist.quotaCusumptionCustomers[idx].intendedQuantity;
  //         }
  //         let AvailableQuota =  quotaDetailslist.quotaCusumptionCustomers[idx].modifiedOrderQtyUoM;
  //         let TotalQuota = AvailableQuota + quotaDetailslist.quotaCusumptionCustomers[idx].consumption;
  //         //let QuotaVolIncrease = packConversion * packSize - details.availableQuota;
  //         //quotaDetailslist.quotaCusumptionCustomers[idx].intendedQuantity = packConversion * packSize;
  //         if (currentWeek === 1) {
  //           if(getQuotaDetails?.depletionModel?.toLowerCase() === "none"){
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].newFinalQuota.weekly1 =
  //             TotalQuota;
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].deltaModification.weekly1 =
  //               quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //                 .weekly1 -
  //               quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
  //                 .weekly1;
  //           }else{
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].newFinalQuota.weekly1 =
  //             TotalQuota;
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].deltaModification.weekly1 =
  //               quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //                 .weekly1 -
  //               quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
  //                 .weekly1;
  //           if (
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly2 <
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly1
  //           ) {
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].newFinalQuota.weekly2 =
  //               quotaDetailslist.quotaCusumptionCustomers[
  //                 idx
  //               ].newFinalQuota.weekly1;
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].deltaModification.weekly2 =
  //               quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //                 .weekly2 -
  //               quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
  //                 .weekly2;
  //           }
  //           if (
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly3 <
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly2
  //           ) {
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].newFinalQuota.weekly3 =
  //               quotaDetailslist.quotaCusumptionCustomers[
  //                 idx
  //               ].newFinalQuota.weekly2;
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].deltaModification.weekly3 =
  //               quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //                 .weekly3 -
  //               quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
  //                 .weekly3;
  //           }
  //           if (
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly4 <
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly3
  //           ) {
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].newFinalQuota.weekly4 =
  //               quotaDetailslist.quotaCusumptionCustomers[
  //                 idx
  //               ].newFinalQuota.weekly3;
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].deltaModification.weekly4 =
  //               quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //                 .weekly4 -
  //               quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
  //                 .weekly4;
  //           }
  //           if (
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly5 <
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly4
  //           ) {
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].newFinalQuota.weekly5 =
  //               quotaDetailslist.quotaCusumptionCustomers[
  //                 idx
  //               ].newFinalQuota.weekly4;
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].deltaModification.weekly5 =
  //               quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //                 .weekly5 -
  //               quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
  //                 .weekly5;
  //           }
  //         }
  //         } else if (currentWeek === 2) {
  //           quotaDetailslist.quotaCusumptionCustomers[
  //             idx
  //           ].newFinalQuota.weekly2 =
  //           TotalQuota;
  //           quotaDetailslist.quotaCusumptionCustomers[
  //             idx
  //           ].deltaModification.weekly2 =
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly2 -
  //             quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
  //               .weekly2;
  //           if (
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly3 <
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly2
  //           ) {
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].newFinalQuota.weekly3 =
  //               quotaDetailslist.quotaCusumptionCustomers[
  //                 idx
  //               ].newFinalQuota.weekly2;
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].deltaModification.weekly3 =
  //               quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //                 .weekly3 -
  //               quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
  //                 .weekly3;
  //           }
  //           if (
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly4 <
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly3
  //           ) {
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].newFinalQuota.weekly4 =
  //               quotaDetailslist.quotaCusumptionCustomers[
  //                 idx
  //               ].newFinalQuota.weekly3;
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].deltaModification.weekly4 =
  //               quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //                 .weekly4 -
  //               quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
  //                 .weekly4;
  //           }
  //           if (
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly5 <
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly4
  //           ) {
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].newFinalQuota.weekly5 =
  //               quotaDetailslist.quotaCusumptionCustomers[
  //                 idx
  //               ].newFinalQuota.weekly4;
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].deltaModification.weekly5 =
  //               quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //                 .weekly5 -
  //               quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
  //                 .weekly5;
  //           }
  //         } else if (currentWeek === 3) {
  //           quotaDetailslist.quotaCusumptionCustomers[
  //             idx
  //           ].newFinalQuota.weekly3 =
  //           TotalQuota;
  //           quotaDetailslist.quotaCusumptionCustomers[
  //             idx
  //           ].deltaModification.weekly3 =
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly3 -
  //             quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
  //               .weekly3;
  //           if (
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly4 <
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly3
  //           ) {
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].newFinalQuota.weekly4 =
  //               quotaDetailslist.quotaCusumptionCustomers[
  //                 idx
  //               ].newFinalQuota.weekly3;
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].deltaModification.weekly4 =
  //               quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //                 .weekly4 -
  //               quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
  //                 .weekly4;
  //           }
  //           if (
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly5 <
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly4
  //           ) {
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].newFinalQuota.weekly5 =
  //               quotaDetailslist.quotaCusumptionCustomers[
  //                 idx
  //               ].newFinalQuota.weekly4;
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].deltaModification.weekly5 =
  //               quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //                 .weekly5 -
  //               quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
  //                 .weekly5;
  //           }
  //         } else if (currentWeek === 4) {
  //           quotaDetailslist.quotaCusumptionCustomers[
  //             idx
  //           ].newFinalQuota.weekly4 =
  //           TotalQuota;
  //           quotaDetailslist.quotaCusumptionCustomers[
  //             idx
  //           ].deltaModification.weekly4 =
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly4 -
  //             quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
  //               .weekly4;
  //           if (
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly5 <
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly4
  //           ) {
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].newFinalQuota.weekly5 =
  //               quotaDetailslist.quotaCusumptionCustomers[
  //                 idx
  //               ].newFinalQuota.weekly4;
  //             quotaDetailslist.quotaCusumptionCustomers[
  //               idx
  //             ].deltaModification.weekly5 =
  //               quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //                 .weekly5 -
  //               quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
  //                 .weekly5;
  //           }
  //         } else if (currentWeek === 5) {
  //           quotaDetailslist.quotaCusumptionCustomers[
  //             idx
  //           ].newFinalQuota.weekly5 =
  //           TotalQuota;
  //           quotaDetailslist.quotaCusumptionCustomers[
  //             idx
  //           ].deltaModification.weekly5 =
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly5 -
  //             quotaDetailslist.quotaCusumptionCustomers[idx].lastApproved
  //               .weekly5;
  //         }
  //         let detailedOrders = customerListDecision[idxs].details.filter(
  //           (x) => Number(x.customerQuotaId) === Number(customerList[i])
  //         );
  //         for (let i = 0; i < detailedOrders.length; i++) {
  //           let Ratio =
  //             detailedOrders[i].intendedQtyUoM /
  //             (quotaDetailslist.quotaCusumptionCustomers[idx].intendedQuantity +
  //               quotaDetailslist.quotaCusumptionCustomers[idx].consumption);
  //           // detailedOrders[i].modifiedQtyPacks = Math.trunc(
  //           //   packConversion * Ratio
  //           // );
  //           // detailedOrders[i].modifiedQtyUoM =
  //           //   detailedOrders[i].modifiedQtyPacks * packSize;
  //           detailedOrders[i].modifiedQtyUoM = Math.round(quotaDetailslist.quotaCusumptionCustomers[idx].modifiedOrderQtyUoM * Ratio);
  //           detailedOrders[i].modifiedQtyPacks = Math.round(detailedOrders[i].modifiedQtyUoM / packSize);
  //         }
  //       }
  //       dispatch(setState("ModifiedList", quotaDetailslist));
  //       dispatch(
  //         setState(
  //           "updatedWeeklyData",
  //           quotaDetailslist?.quotaCusumptionCustomers
  //         )
  //       );
  //       dispatch(
  //         setState("customerListForDecisionSubmission", customerListDecision)
  //       );
  //       //////////////to be changed here
  //       if (rowSelectionModel?.length === quotaConsumptionTableState?.length) {
  //         let detailsList = [];
  //         for (let r = 0; r < quotaConsumptionTableState?.length; r++) {
  //           detailsList.push(
  //             quotaDetailslist.quotaCusumptionCustomers.find(
  //               (x) =>
  //                 x.customerQuotaID ===
  //                 quotaConsumptionTableState[r].customerQuotaID
  //             )
  //           );
  //         }
  //         dispatch(setState("modifyList", detailsList));
  //         dispatch(setState("CustomerSearchTxt", searchCustomer));
  //         dispatch(setState("ProductSearchTxt", searchProduct));
  //         dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
  //       } else {
  //         dispatch(
  //           setState("modifyList", quotaDetailslist?.quotaCusumptionCustomers)
  //         );
  //         dispatch(setState("CustomerSearchTxt", ""));
  //         dispatch(setState("ProductSearchTxt", ""));
  //         dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
  //       }
  //       dispatch(setState("displayModification", true));
  //       setIsModificationOpened(true);
  //     }
  //   } else if (onMSQClicked) {
  //     if (customerListForDecision?.length > 0) {
  //       let customerList = [];
  //       let customerListDecision = JSON.parse(
  //         JSON.stringify(customerListForDecision)
  //       );
  //       for (let i = 0; i < rowSelectionModel.length; i++) {
  //         const row = rows.find(
  //           (row) => row.customerQuotaID === rowSelectionModel[i]
  //         );
  //         if (row["orderStatus"].toLowerCase() == "blocked") {
  //           customerList.push(row.customerQuotaID);
  //         }
  //       }
  //       dispatch(setState("selectedCustomersForDecision", customerList));
  //       let quotaDetailslist = JSON.parse(JSON.stringify(getQuotaDetails));
  //       let idxs = -1;
  //       for (let i = 0; i < customerList.length; i++) {
  //         let details = {};
  //         for (let j = 0; j < customerListForDecision.length; j++) {
  //           let Ind = customerListForDecision[j].details.findIndex(
  //             (x) => Number(x.customerQuotaId) === Number(customerList[i])
  //           );
  //           if (Ind > -1) {
  //             details = customerListForDecision[j].details[Ind];
  //             idxs = j;
  //             break;
  //           }
  //         }
  //         let packSize = details.packSize;
  //         let idx = quotaDetailslist.quotaCusumptionCustomers.findIndex(
  //           (x) => x.customerQuotaID === Number(customerList[i])
  //         );
  //         let quota = 0;
  //         if (currentWeek === 1)
  //           quota =
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly1;
  //         if (currentWeek === 2)
  //           quota =
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly2;
  //         if (currentWeek === 3)
  //           quota =
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly3;
  //         if (currentWeek === 4)
  //           quota =
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly4;
  //         if (currentWeek === 5)
  //           quota =
  //             quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
  //               .weekly5;

  //         let availableQuota =
  //           quota - quotaDetailslist.quotaCusumptionCustomers[idx].consumption;
  //         quotaDetailslist.quotaCusumptionCustomers[idx].modifiedOrderQtyUoM =
  //           availableQuota;
  //         let packConversion = Math.round(availableQuota / packSize);

  //         let detailedOrders = customerListDecision[idxs].details.filter(
  //           (x) => Number(x.customerQuotaId) === Number(customerList[i])
  //         );
  //         for (let i = 0; i < detailedOrders.length; i++) {
  //           let Ratio =
  //             detailedOrders[i].intendedQtyUoM /
  //             (quotaDetailslist.quotaCusumptionCustomers[idx].intendedQuantity +
  //               quotaDetailslist.quotaCusumptionCustomers[idx].consumption);
  //           // detailedOrders[i].modifiedQtyPacks = Math.trunc(
  //           //   packConversion * Ratio
  //           // );
  //           // detailedOrders[i].modifiedQtyUoM =
  //           //   detailedOrders[i].modifiedQtyPacks * packSize;
  //           detailedOrders[i].modifiedQtyUoM = Math.round(quotaDetailslist.quotaCusumptionCustomers[idx].modifiedOrderQtyUoM * Ratio);
  //           detailedOrders[i].modifiedQtyPacks = Math.round(detailedOrders[i].modifiedQtyUoM / packSize);
  //         }
  //       }
  //       dispatch(setState("ModifiedList", quotaDetailslist));
  //       dispatch(
  //         setState(
  //           "updatedWeeklyData",
  //           quotaDetailslist?.quotaCusumptionCustomers
  //         )
  //       );
  //       dispatch(
  //         setState("customerListForDecisionSubmission", customerListDecision)
  //       );
  //     }
  //   }
  // }, [customerListForDecision]);

  let visibleColumns = [];

  let arr = ["weekly2", "weekly3", "weekly4", "weekly5"];
  if (getQuotaDetails?.depletionModel?.toLowerCase() === "none") {
    visibleColumns = columns.filter(
      (col) =>
        col.field !== "weekly2" &&
        col.field !== "weekly3" &&
        col.field !== "weekly4" &&
        col.field !== "weekly5"
    );
  } else if (getQuotaDetails?.depletionModel?.toLowerCase() === "biweekly") {
    visibleColumns = columns.filter(
      (col) =>
        col.field !== "weekly3" &&
        col.field !== "weekly4" &&
        col.field !== "weekly5"
    );
  } else {
    visibleColumns = columns;
  }

  const handleBlockedOrders = () => {
    let customerList = [];
    for (let i = 0; i < rowSelectionModel.length; i++) {
      const row = rows.find(
        (row) => row.customerQuotaID === rowSelectionModel[i]
      );
      if (row["orderStatus"].toLowerCase() == "blocked") {
        customerList.push(row.customerQuotaID);
      }
      // customerList.push(row["id"]);
    }
    if (customerList.length == 0) {
      console.log("Please select blocked customer(s)");
      showMessage("Please select blocked customer(s)", "info");
      return;
    }

    let obj = {
      blockedcustomers: customerList,
      countryId: getScenarios.find((x) => x.scenarioID === selectedScenarioID)
        .geoID,
      isDisplayOnlyBlockedOrder: 1,
      sceanrioName: selectedScenarioName,
      scenarioId: selectedScenarioID,
      selectedNumberOfDays: 1,
    };
    let newObj = {
      blockedcustomers: customerList,
      countryId: getScenarios.find((x) => x.scenarioID === selectedScenarioID)
        .geoID,
      isDisplayOnlyBlockedOrder: 1,
      sceanrioName: selectedScenarioName,
      scenarioId: selectedScenarioID,
      selectedNumberOfDays: 1,
      selectedQuotaID: selectedQuotaID,
    };
    dispatch(setState("orderParameters", newObj));
    //console.log(obj);
    dispatch(GetBlockedCustomersConsumption(obj));
    handleOpen();
    dispatch(setState("openModifyOrders", true));
  };

  const getRowClassName = (params) => {
    return params.row.isModified ? "modified-row" : "";
  };

  useEffect(() => {
    if (omIsDisplayBlocked) {
      setIsDisplayBlockedCustomers(true);
    }
  }, [omIsDisplayBlocked]);

  useEffect(()=>{
    if (
      onUnblockClickedSubmitted &&
      modificationId !== null &&
      modificationId !== 0
    ){
      debugger
      if(onUnblockClicked){
        handleSaveOrderDecision("fullorder");
      }else if(onMSQClicked){
        handleSaveOrderDecision("stickModify");
      }
      dispatch(setState("onUnblockClicked", false));
      dispatch(setState("onMSQClicked", false));
      dispatch(setState("onUnblockClickedSubmitted", false));
      dispatch(setState("modificationId", 0));
    }
  }, [modificationId])

  const handleSaveOrderDecision = (Code) => {
    debugger
    dispatch(setState("Code", Code));
    let decisionCode = '';
    let desSucmessage = 'Orders decision updated successfully.';
    let desSucPartmessage = 'Orders decision updated successfully for some of the selected customer(s)';

    if (Code === 'stick' || Code === 'stickModify') {
      decisionCode = 'SQ';
      desSucmessage = 'Stick to quota orders decision updated successfully.';
      desSucPartmessage = 'Stick to quota Orders decision updated successfully for some of the selected customer(s)';
    } else if (Code === 'nothing') {
      decisionCode = 'ND';
      desSucmessage = 'Do nothing orders decision updated successfully.';
      desSucPartmessage = 'Do nothing Orders decision updated successfully for some of the selected customer(s)';
    } else if (Code === 'fullorder') {
      decisionCode = 'UB';
    }
    dispatch(setState("decisionCode", decisionCode));
    dispatch(setState("desSucmessage", desSucmessage));
    dispatch(setState("desSucPartmessage", desSucPartmessage));

    let customerList = [];
    for (let i = 0; i < rowSelectionModel.length; i++) {
      const row = rows.find(
        (row) => row.customerQuotaID === rowSelectionModel[i]
      );
      if (row["orderStatus"].toLowerCase() == "blocked") {
        customerList.push(row.customerQuotaID);
      }
      // customerList.push(row["id"]);
    }

    if (customerList.length === 0) {
      showMessage('Please select blocked customer(s)', 'info');
      return;
    } else {
      const newObj = {
        scenarioId: selectedScenarioID,
        quotaId: selectedQuotaID,
      };
      let uniqueCustomer = [...new Set(customerList)];
      let geoid = getScenarios.find(
        (x) => x.scenarioID === newObj.scenarioId
      ).geoID;
      let obj = {
        countryId : geoid,
        scenarioId: selectedScenarioID,
        sceanrioName: selectedScenario,
        blockedcustomers: uniqueCustomer,
        quotaId: selectedQuotaID,
        userId: JSON.parse(localStorage.getItem("data")).userID,
        decisionCode: decisionCode,
        modificationId: (Code === 'stickModify' || Code === 'fullorder') ? modificationId : 0,
      };
      dispatch(SubmitOrderDecision(obj)).then(() =>
        dispatch(GetQuotaDetailsForScenario(newObj))
      );
    }
  };
 
  const handleFullOrderModification = (type) => {
    let isSQorUB = true;
    let customerList = [];

    for (let i = 0; i < rowSelectionModel.length; i++) {
      const row = rows.find(
        (row) => row.customerQuotaID === rowSelectionModel[i]
      );
      if (row["orderStatus"].toLowerCase() == "blocked") {
        customerList.push(row.customerQuotaID);
      }
      // customerList.push(row["id"]);
    }

    if (customerList.length === 0) {
      showMessage('Please select blocked customer(s)', 'info');
      return;
    }

    if (type === 'UnblockFullOrder') {
      let isFullOrderModification = true;
      setIsFullOrderModification(true);
      handleRetrive(false, customerList, isFullOrderModification);
      dispatch(setState("onUnblockClicked", true));
      dispatch(setState("onMSQClicked", false));
    } else {
      let isStickToQuota = true;
      setIsStickToQuota(true);
      handleRetrive(false, [], false);
      dispatch(setState("onMSQClicked", true));
      dispatch(setState("onUnblockClicked", false));
    }
  };
  const handleRowSelectionChange = (newRowSelectionModel) => {
    let rowSelected = [];
    for(let i = 0; i< prevRowSelectionModel?.current?.length; i++){
      let idx = rows.findIndex(x => x.customerQuotaID === prevRowSelectionModel.current[i]);
      if(idx === -1){
        rowSelected.push(prevRowSelectionModel.current[i]);
      }
    }
    const mergedSelectionModel = Array.from(new Set([...rowSelected, ...newRowSelectionModel]));
    prevRowSelectionModel.current = mergedSelectionModel;
    setRowSelectionModel(mergedSelectionModel);
  }

  return (
    <div>
      <Box mt={2}>
        <Box>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={isLoading}
          >
            <CircularProgress />
          </Backdrop>
        </Box>

        <Grid
          container
          columns={12}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          pb={1}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography variant="subtitle1">
              Scenario of : {selectedScenario}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={3} md={3} lg={3}>
            <TextField
              variant="outlined"
              label="Search Customer"
              value={searchCustomer}
              onChange={handleSearchCustomer}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  // Prevents autoselecting item while typing (default Select behaviour)
                  e.stopPropagation();
                }
              }}
              fullWidth
              size="small"
            ></TextField>
          </Grid>
          <Grid item xs={6} sm={3} md={3} lg={3}>
            <TextField
              variant="outlined"
              label="Search Product"
              value={searchProduct}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  // Prevents autoselecting item while typing (default Select behaviour)
                  e.stopPropagation();
                }
              }}
              onChange={handleSearchProduct}
              fullWidth
              size="small"
            ></TextField>
          </Grid>
          <Grid item xs={6} sm={3} md={3} lg={3}>
            <FormControlLabel
              label="List Only Blocked Customers"
              control={
                <Checkbox
                  checked={isDisplayBlockedCustomers}
                  onChange={(e) =>
                    setIsDisplayBlockedCustomers(e.target.checked)
                  }
                  //onChange = {handleisDisplayBlocked}
                />
              }
            />
          </Grid>
          <Grid item xs={12} sm={3} md={3} lg={3}>
            {getQuotaDetails?.quotaCusumptionCustomers?.length > 0 && <ExportIcons />}
          </Grid>
          <Grid item xs={12} sm={3} md={3} lg={3}>
            {/* <Box justifyContent="center" display="flex">
                            <Button
                                startIcon={<EditIcon />}
                                variant="contained"
                                onClick={handleRetrive}
                                size="large"
                            // className="mui_Button"
                            //disabled={Object.keys(selectedPeriod).length === 0 || loadQuotaDetails ? true : false}
                            >
                                Modify Quota
                            </Button>
                        </Box> */}
          </Grid>
        </Grid>
        {rows && 
         rows.length > 0 && 
         ((searchCustomer !== undefined && searchCustomer !== "") || 
          (searchProduct !== undefined && searchProduct !== "")) && (
          <Box m={2} mt={3}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                fontSize: "16px",
                fontFamily: "Montserrat, Sans-serif",
                color:"darkred.light",
                mb: 2,
              }}
            >
              Total
            </Typography>
            <TotalValueQC
              rows={rows}
              visibleColumns={visibleColumns}
              getQuotaDetails={getQuotaDetails}
              currentWeek={currentWeek}
            />
          </Box>
        )}
        {getQuotaDetails?.quotaCusumptionCustomers?.length > 0 && (
          <Box sx={{ mt: 3 }} ref={QCRef}>
            <DataGridPro
              //style={{ maxHeight: "calc(100vh - 130px)" }}
              rows={rows || []}
              columns={visibleColumns}
              getRowId={(row) => row?.customerQuotaID}
              sx={{
                "& .MuiDataGrid-columnHeaderTitleContainer": {
                  fontWeight: "bold !important",
                  fontSize: "14px",
                  fontFamily: "Montserrat, Sans-serif",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  whiteSpace: "normal",
                  lineHeight: "normal",
                  fontWeight: "bold",
                  fontSize: "14px",
                  fontFamily: "Montserrat, Sans-serif",
                },
                "& .MuiDataGrid-columnHeader": {
                  // Forced to use !important since overriding inline styles
                  height: "unset !important",
                },
                "& .MuiDataGrid-columnHeaders": {
                  // Forced to use !important since overriding inline styles
                  maxHeight: "168px !important",
                },
                ...(!isAll ? {
                  "& .MuiDataGrid-virtualScroller": {
                     maxHeight: "unset !important"
                  }
                } : {
                  "& .MuiDataGrid-virtualScroller": {
                     maxHeight: "80vh !important"
                  }
                })
              }}
              // paginationMode="client"
              rowSelectionModel={rowSelectionModel}
              //checkboxSelection={true}
              checkboxSelection
              isRowSelectable={(params) => params.row.customerQuotas_SentToSAP === 'Y'}
              disableRowSelectionOnClick
              disableColumnMenu
              onRowSelectionModelChange={(newRowSelectionModel) => {
                handleRowSelectionChange(newRowSelectionModel);
              }}
              getRowClassName={getRowClassName}
              headerHeight={40}
              rowHeight = {43}
              autoHeight = {false}
              //rowBuffer = {20}
              //rowBufferPx = {100}
              initialState={{
                pagination: { paginationModel: { pageSize:20, page:0 }}
              }}
              pagination
              pageSizeOptions={[20, 50, 100, { value: muiConfig.DataGrid_All , label: 'All' }]}
              paginationModel={paginationModel}
              onPaginationModelChange = {setModal}	
              //onColumnHeaderClick={handleHeaderCellClick}
              //onRowClick={handleRowClick}
            />
          </Box>
        )}

        <Box mt={3}>
          <Grid
            container
            columns={6}
            justifyContent="flex-end"
            spacing={2}
            pb={2} 
            sx={{paddingLeft : "0px !important",
            ' & .MuiGrid-item': {
              paddingLeft: "0px !important",
            }
          }}
          >
            {/* <Grid item xs={6} sm={1} md={1} lg={0.8}>
              <Button
                startIcon={<EditIcon />}
                sx={{ minWidth: 200, height: 45 }}
                variant="contained"
                id="SearchButton"
                disabled={!isRestrictedAccess}
                style={{
                  // background: "#286aa6",
                  color: "white",
                  borderRadius: "4px",
                  textTransform: "none",
                }}
                onClick={handleBlockedOrders}
              >
                Edit Blocked Orders
              </Button>
            </Grid> */}

            <Grid item xs={6} sm={2} md={0.8} lg={0.55} sx={{ ml: 1.5, pl:0 }}>
              <Button
                startIcon={<LabelImportantRoundedIcon />}
                id="SearchButton"
                disabled={!isRestrictedAccess}
                sx={{
                  bgcolor: "#ee1100",
                  color: "white.main",
                  fontWeight: "700",
                  textTransform: "none",
                  "&:hover": {
                     bgcolor: "white.main",
                     borderColor: "#ee1100",
                     color: "#ee1100",
                  },
                  minWidth: 120, height: 45,
                  borderColor: "#ee1100",
                }}
                variant="outlined"
                onClick={() => handleSaveOrderDecision("stick")}
              >
                Stick to quota
              </Button>
            </Grid>

            <Grid item xs={6} sm={2} md={1.18} lg={0.8} sx={{ ml: 1.5 , pl:0 }}>
              <Button
                startIcon={<DownloadDoneRoundedIcon />}
                id="SearchButton"
                //disabled={!isRestrictedAccess}
                onClick={() => handleFullOrderModification('STQandModify')}
                sx={{
                  bgcolor: "rgb(242, 157, 0)",
                  color: "white.main",
                  fontWeight: "700",
                  textTransform: "none",
                  "&:hover": {
                     bgcolor: "white.main",
                     color: "rgb(242, 157, 0)",
                     borderColor: "rgb(242, 157, 0)"
                  },
                  height: 45,
                  borderColor: "rgb(242, 157, 0)"
                }}
                variant="outlined"
                //onClick={DisplayDiv}
              >
                Modify + Stick to Quota{" "}
              </Button>
            </Grid>

            <Grid item xs={6} sm={2} md={1} lg={0.65} sx={{ ml: 1.5, pl:0  }}>
              <Button
                startIcon={<LockOpenRoundedIcon />}
                //disabled={!isRestrictedAccess}
                sx={{
                  bgcolor: "#f7ce03",
                  color: "white.main",
                  fontWeight: "700",
                  textTransform: "none",
                  "&:hover": {
                     bgcolor: "white.main",
                     color: "#f7ce03",
                     borderColor: "#f7ce03"
                  },
                  height: 45,
                  borderColor: "#f7ce03"
                }}
                variant="outlined"
                id="SearchButton"
                onClick={() => handleFullOrderModification('UnblockFullOrder')}
              >
                Unblock full order
              </Button>
            </Grid>

            <Grid item xs={6} sm={2} md={1} lg={0.45} sx={{ ml: 1.5, pl:0  }}>
              <Button
                //startIcon={<LockOpenRoundedIcon />}
                sx={{ height: 45 }}
                disabled={!isRestrictedAccess}
                style={{
                  background: "#FFF",
                  color: "#000",
                  borderRadius: "4px",
                  textTransform: "none",
                  borderColor : "#000"
                }}
                variant="outlined"
                onClick={() => handleSaveOrderDecision('nothing')}
                id="SearchButton"
                // onClick={DisplayDiv}
              >
                <strong>Do Nothing</strong>
              </Button>
            </Grid>

            <Grid item xs={6} sm={2} md={0.8} lg={0.6} sx={{ ml: 2, pl:0  }}>
                <Button
                  startIcon={<EditIcon />}
                  onClick={() => handleRetrive(false, [], false)}
                  size="large"
                  variant="outlined"
                  disabled={
                    getQuotaDetails?.isModified &&
                    (getQuotaDetails?.status.toLowerCase() === "submitted" ||
                      getQuotaDetails?.status.toLowerCase() ===
                        "locally approved")
                      ? true
                      : false
                  }
                  sx={{
                    bgcolor: "#FFF",
                    color: "#000000",
                    fontWeight: "700",
                    borderRadius: "4px",
                    borderColor : "#000",
                    textTransform: "none",
                    "&:hover": {
                       bgcolor: "#ee1100",
                       color: "#ffffff",
                       borderColor: "#ee1100"
                    },
                    height: 45
                  }}
                  // className="mui_Button"
                  //disabled={Object.keys(selectedPeriod).length === 0 || loadQuotaDetails ? true : false}
                >
                  Modify Quota
                </Button>
            </Grid>

            <Grid item xs={6} sm={2} md={0.8} lg={0.75} sx={{ ml: 1.5, pl:0  }}>
                <Button
                  disabled={isRestrictedAccess === false ? true :
                    getQuotaDetails?.isModified &&
                    (getQuotaDetails?.status.toLowerCase() === "submitted" ||
                      getQuotaDetails?.status.toLowerCase() ===
                        "locally approved")
                      ? false
                      : true
                  }
                  sx={{
                    height: 45,
                    visibility: isRestrictedAccess === false ? "none" :
                      getQuotaDetails?.isModified &&
                      (getQuotaDetails?.status.toLowerCase() === "submitted" ||
                        getQuotaDetails?.status.toLowerCase() ===
                          "locally approved")
                        ? "visible"
                        : "none",
                      bgcolor: "#FFF",
                      color: "#000000",
                      borderRadius: "4px",
                      borderColor : "#000",
                      fontWeight: "700",
                      textTransform: "none",
                      "&:hover": {
                        bgcolor: "#ee1100",
                        color: "#ffffff",
                        borderColor: "#ee1100"
                      },
                  }}
                  startIcon={<EditIcon />}
                  variant="outlined"
                  onClick={handleRecallModification}
                  size="large"
                  // className="mui_Button"
                  //disabled={Object.keys(selectedPeriod).length === 0 || loadQuotaDetails ? true : false}
                >
                  Recall Modification
                </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <ModifyOrders />
    </div>
  );
};

export default QuotaandConsumption;
